/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class IndexRoute extends Route {
  queryParams = {
    ledgerId: {
      refreshModel: true,
      as: 'ledger',
    },
    year: {
      refreshModel: true,
    },
  };

  // Services
  @service
  features;

  @service
  store;

  model(params) {
    let groupParams = {};
    if (isEmpty(params.ledgerId)) {
      delete params.ledgerId;
    }
    if (isEmpty(params.year)) {
      delete params.year;
    } else {
      groupParams.year = params.year;
    }

    let promises = {
      items: this.store.query('finance/ledger-item', params),
      ledgers: this.store.findAll('finance/ledger'),
      accounts: this.store.query('finance/account', { isActive: true }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      // Groups are used for filtering/selection
      groups: this.store.query('group', groupParams),
    };

    if (this.features.sapFinance) {
      // Add extra SAP entities if required.
      promises.costCentres = this.store.findAll('finance/cost-centre');
      promises.internalOrders = this.store.findAll('finance/internal-order');
    }

    return hash(promises);
  }
}
